import Vue from "vue";

const rawMenu = [
  {
    title: "主页",
    route: "home",
    icon: "HomeIcon",
  },
  {
    header: "开放平台",
  },
  {
    title: "应用管理",
    route: "App",
    icon: "GridIcon",
  },
  {
    header: "系统管理",
    permission: "root",
  },
  {
    title: "用户管理",
    route: "CompanyUser",
    icon: "UsersIcon",
    permission: "root",
  },
  {
    title: "公司管理",
    route: "Company",
    icon: "TrelloIcon",
    permission: "root",
  },
  {
    title: "权限设置",
    route: "Business",
    icon: "LayersIcon",
    permission: "root",
  },
];

export default async function loadMenuData() {
  var user = await Vue.prototype.$http.get("/Account/GetUserInfo");
  if (user.is_root === 1) {
    return rawMenu;
  } else {
    return rawMenu.filter((item) => {
      return item.permission !== "root";
    });
  }
}
